import { Link } from 'react-router-dom';
import InfoLists from '../component/InfoLists';
import SEO, { seoConfig } from '../component/SEO';
import ImageGenerateAds from '../Ads/ImageGenerateAds';
import { title } from '../config/config';

const About = () => {


     return (

          <>
          <SEO {...seoConfig.about} />

          <div className="about-hero-theme">
               {/* 1. FLOATING 3D SHAPES BACKGROUND (Matched with image_1.png) */}
               <div className="floating-elements">
                    <div className="el sphere-blue"></div>
                    <div className="el cube-pink"></div>
                    <div className="el torus-teal"></div>
                    <div className="el triangle-orange"></div>
               </div>

               <main className="about-content-wrapper">
                    {/* SECTION 1: THE MISSION (Bold & Direct) */}
                    <div className="about-header">
                         <div className="badge">Our Mission</div>
                         <h1>Forging Clarity from <span>Raw Thoughts.</span></h1>
                         <p className="sub-text">
                              {title} isn't just a tool; it's a movement towards minimal, structured creation.
                              We are here to help you move from a messy note to a validated project in minutes.
                         </p>
                    </div>

                    {/* SECTION 2: THE ECOSYSTEM (Icon Grid - New Visual) */}
                    <section className="about-ecosystem">
                         <h2>The <span>Independent</span> Workspace</h2>
                         <div className="eco-grid">
                              <div className="eco-item">
                                   <div className="icon">💡</div>
                                   <h4>Capture Raw Concepts</h4>
                                   <p>A structured project starts with a clean slate to structure your messiest thoughts.</p>
                              </div>
                              <div className="eco-item">
                                   <div className="icon">🛠️</div>
                                   <h4>Validate Effectively</h4>
                                   <p>Use our collaboration tools to validate and organize your concepts rapidly.</p>
                              </div>
                              <div className="eco-item">
                                   <div className="icon">🚀</div>
                                   <h4>Launch Confidently</h4>
                                   <p>Independent ecosystem built to forge your next big idea under the TheDC brand.</p>
                              </div>
                         </div>
                    </section>

                    {/* SECTION 3: THE CREATOR (Minimal Founder Card - image_1.png style) */}
                    <section className="about-creator">
                         <div className="creator-card">
                              <img src="https://heyprompt.online/static/media/seo.6586e8256d4e9157b55a.png" alt="Sunil Sharma" />
                              <div className="info">
                                   <h3>Sunil Sharma, ( Thedc )</h3>
                                   <p className="title">Founder, Builder, Vision Driver </p>
                                   <p className="quote">"Built with 'TheDC' philosophy of minimalist tech—for independent creators."</p>
                              </div>
                         </div>

                           <ImageGenerateAds />
                    </section>

                    <InfoLists/>

                    {/* SECTION 5: CONTACT (Clean CTA) */}
                    <section className="about-contact">
                         <h3>Let's Build Together.</h3>
                         <p>Questions? Vision? Collaborate? Reach us at: <strong>thedc.here@gmail.com</strong></p>
                         <Link to="https://buildifytool.cloud/" target='_blank' className="contact-btn">Pitch Your Concept</Link>
                    </section>

               </main>
          </div>

          </>

     );
};

export default About;